import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';
import { FEEDBACK_FORM_TYPES } from '../util/constants.js';
import { validateAuth, getApiBaseUrl } from '../util/util.js';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { userTypeSelector } from '../redux/selectors.js';
import { notificationSuccess, notificationError } from '../redux/actions/app.js';
import { capitalizeName } from '../util/util.js';
import { StyledContainer } from '../dynamicform/styled.js';
import FeedbackContactForm from './shared/FeedbackContactForm.jsx';

const Feedback = ({ show = false, sidebarExpanded, setShowFeedbackForm }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const currentUserType = useSelector(userTypeSelector);
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    if (!show) setFormKey((k) => k + 1);
  }, [show]);

  const handleSubmit = ({ type, description }) => {
    const payload = {
      type,
      description,
      email: currentUserType.user.email,
      name: capitalizeName(currentUserType.user.name),
    };
    sendFeedback(payload);
  };

  const sendFeedback = (payload) => {
    validateAuth((session) => {
      axios
        .post(`${getApiBaseUrl(currentUserType.type)}/feedback`, payload, {
          headers: {
            Authorization: session.getIdToken().getJwtToken(),
          },
          timeout: 15 * 1000,
        })
        .then((response) => {
          dispatch(notificationSuccess('Successfully sent feedback'));
          setTimeout(() => {
            setShowFeedbackForm(false);
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
          dispatch(notificationError(error));
        });
    });
  };

  return (
    <StyledContainer
      className="col gap-lg"
      style={{
        position: 'fixed',
        left: sidebarExpanded ? `calc(440px + 16px)` : 'calc(72px + 16px)',
        bottom: theme.spacing(2),
        zIndex: 1202,
        width: '380px',
        padding: theme.spacing(2),
        height: 'fit-content',
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.1)',
        opacity: show ? '100%' : '0',
        pointerEvents: show ? 'all' : 'none',
        transition: 'left .25s ease-in-out, opacity .15s ease-in-out',
      }}
    >
      <FeedbackContactForm
        key={formKey}
        title="Send Feedback"
        selectLabel="Feedback Type"
        selectOptions={FEEDBACK_FORM_TYPES}
        descriptionLabel="Your Feedback"
        maxDescLength={2000}
        onSubmit={handleSubmit}
        onClose={() => setShowFeedbackForm(false)}
      />
    </StyledContainer>
  );
};

export default Feedback;
